<template>
    <div class="banner">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-5 col-lg-4 mb-4" :class="{'col-md-12 col-lg-12': !showMap}">
                    <span class="badge badge-light text-uppercase">{{ network.type }} Network</span>
                    <h1 class="title">{{ network.name }} Network</h1>
                    <h2 v-if="showCitiesCount">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12.868" height="15.533" viewBox="0 0 12.868 15.533"><g transform="translate(-5.885 -1.104)"><path class="a" d="M6.434,15.533h0L1.884,10.984a6.435,6.435,0,0,1,9.1-9.1,6.434,6.434,0,0,1,0,9.1L6.435,15.533Zm0-12.153A2.987,2.987,0,1,0,9.421,6.369,2.991,2.991,0,0,0,6.433,3.381Z" transform="translate(5.885 1.104)"/></g></svg>
                        {{ cityCount }} {{ 'City' | pluralize(cityCount, 'Cities') }}
                    </h2>
                    <h2><i class="icons8-user-account"></i>{{ memberCount | formatNumber }} {{ 'Member' | pluralize(memberCount) }}</h2>
                </div>
                <div class="col-md-7 col-lg-8 map" v-if="showMap">
                    <google-map :markers="mapMarkers" dark-theme></google-map>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GoogleMap from "@/components/global/GoogleMap";

export default{
    name: 'network-map-card',
    components:{
        GoogleMap
    },
    props: {
        network: {
            type: Object,
            default() {
                return {}
            }
        },
        showMap: {
            type: Boolean,
            default: true
        },
        showCitiesCount: {
            type: Boolean,
            default: true
        }
    },
    computed:{
        mapMarkers(){
            return this.network.countries.filter(country => {
                return country.membercount > 0
            }).map((country) => {
                return {
                    ...country.country,
                    citycount: country.citycount,
                    membercount: country.membercount
                }
            }).sort((a,b) => b.membercount - a.membercount);
        },
        cityCount(){
            var count = 0;
            this.network.countries.forEach(country =>{
                count += country.citycount;
            })
            return count;
        },
        memberCount(){
            var count = 0;
            this.network.countries.forEach(country =>{
                count += country.membercount;
            })
            return count;
        }
    }
}
</script>

<style lang="scss" scoped>
    .banner {
        background-color: $secondary;
        color: #ffffff;
        padding: 35px 0 0px;
        text-align: center;

        @include media-breakpoint-up(md) {
            text-align: left;
            padding: 0;
        }

        .badge {
            background-color: $dark-grey;
            border-radius: 3px;
            letter-spacing: 0.6px;
            color: $grey-text;
            padding: 7px 15px;
            margin-bottom: 15px;
            margin-top: 20px;
            @include media-breakpoint-up(lg) {
                margin-top: 0;
            }
        }

        h1.title {
            font-weight: 900;
            margin-bottom: 25px;
            font-size: 40px;
            line-height: 1.4;
            @include media-breakpoint-up(md) {
                font-size: 33px;
                line-height: 1.2;
            }
            @include media-breakpoint-up(lg) {
                // font-size: 40px;
                margin-bottom: 40px;
            }
            @include media-breakpoint-up(xl) {
                font-size: 40px;
                line-height: 1.4;
            }
        }
        h2 {
            font-weight: 400;
            color: $grey-text;
        }

        svg {
            height: 24px;
            width: 24px;
            margin-top: -8px;
            path {
                fill: $dark-grey;
            }
        }

        i {
            font-size: 26px;
            color: $dark-grey;
            vertical-align: middle;
        }

        i,
        svg {
            margin-right: 10px;
        }

        .map {
            padding: 0;
            position: static;
            height: 266px;
            @include media-breakpoint-up(md) {
                position: relative;
                height: auto;
            }
            @include media-breakpoint-up(lg) {
            }
        }
    }
</style>
